(function () {
  function initRoot(root) {
    // Read toggle + delay from data-attributes
    var enabledAttr = (root.getAttribute('data-autoplay') || '').toString().toLowerCase();
    var enabled = !(enabledAttr === 'false' || enabledAttr === '0' || enabledAttr === 'off' || enabledAttr === '');
    if (!enabled) return;

    var delay = parseInt(root.getAttribute('data-autoplay-delay'), 10);
    if (!isFinite(delay) || delay <= 0) delay = 5000;

    var items = root.querySelectorAll('.js-slider-item');
    if (!items || items.length < 2) return;

    // Prefer native next button if present
    var nextBtn = root.querySelector('.css-slider-next');
    var idx = 0;
    var timer = null;

    function next() {
      if (nextBtn) {
        nextBtn.click();
      } else {
        idx = (idx + 1) % items.length;
        items[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    function start() {
      stop();
      timer = setInterval(next, delay);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    // Hover pause
    root.addEventListener('mouseenter', stop, { passive: true });
    root.addEventListener('mouseleave', start, { passive: true });

    // Pause when tab hidden
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    // Rebind if section reloaded in Theme Editor
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.contains(root)) {
        nextBtn = root.querySelector('.css-slider-next');
        start();
      }
    }, { passive: true });

    start();
  }

  function boot() {
    document.querySelectorAll('.js-autoplay-slider').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
